import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FacebookReactionType } from '@sb-tools/typescript/enums/facebook-reaction-type.enum';
import { FacebookReaction } from '@sb-tools/typescript/models/facebook-reaction.model';
import { ReactionTooltipTextType } from '../../../../core/enums/reaction-tooltip-text-type.enum';
import { InlineSVGComponent } from '../../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { NgClass } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ReplaceEmojisPipe } from '../../../../../sb-tools/typescript/pipes/replace-emoji/replace-emojis.pipe';
import { SafeHtmlPipe } from '../../../../../sb-tools/typescript/pipes/safe-html.pipe';

@Component({
    selector: 'app-reaction-icon',
    templateUrl: './reaction-icon.component.html',
    styleUrls: ['./reaction-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [InlineSVGComponent, NgClass, TooltipModule, ReplaceEmojisPipe, SafeHtmlPipe],
})
export class ReactionIconComponent {
    @Input() isShowReactionCount?: boolean;
    @Input() isSingleEmoji?: boolean;
    @Input() reaction: FacebookReaction;
    @Input() tooltipTextType?: ReactionTooltipTextType;

    facebookReactionType = FacebookReactionType;
    reactionTooltipTextType = ReactionTooltipTextType;
    standardFacebookReactionsList = [];

    constructor() {
        this.standardFacebookReactionsList = [
            this.facebookReactionType.angry,
            this.facebookReactionType.like,
            this.facebookReactionType.love,
            this.facebookReactionType.haha,
            this.facebookReactionType.wow,
            this.facebookReactionType.sad,
        ];
    }
}
